import React from "react";
import { useTranslation } from "react-i18next";

const TermsCondition = () => {
  const { t } = useTranslation();
  const termsCondition = [
    {
      title: t("terms-and-conditions.title1"),
      content: (
        <p className="exado-subTitle-two">
          {t("terms-and-conditions.content1.line1")}
          <br />
          <br />
          {t("terms-and-conditions.content1.line2")}
          <br />
          <br />
          {t("terms-and-conditions.content1.line3")}
        </p>
      ),
    },
    {
      title: t("terms-and-conditions.title2"),
      content: (
        <p className="exado-subTitle-two">
          {t("terms-and-conditions.content2.line1")}
          <br />
          <br />
          {t("terms-and-conditions.content2.line2")}
          <br />
          <br />
          {t("terms-and-conditions.content2.line3")}
          <br />
          <br />
          {t("terms-and-conditions.content2.line4")}
        </p>
      ),
    },
    {
      title: t("terms-and-conditions.title3"),
      content: (
        <div className="exado-subTitle-two">
          <p>{t("terms-and-conditions.content3.line1")}</p>
          <ol className="ps-5">
            <li className="ps-5">
              {" "}
              {t("terms-and-conditions.content3.list1")}{" "}
            </li>
            <li className="ps-5">
              {" "}
              {t("terms-and-conditions.content3.list2")}{" "}
            </li>
            <li className="ps-5">
              {" "}
              {t("terms-and-conditions.content3.list3")}{" "}
            </li>
            <li className="ps-5">
              {" "}
              {t("terms-and-conditions.content3.list4")}{" "}
            </li>
            <li className="ps-5">
              {" "}
              {t("terms-and-conditions.content3.list5")}{" "}
            </li>
            <li className="ps-5">
              {" "}
              {t("terms-and-conditions.content3.list6")}{" "}
            </li>
            <li className="ps-5">
              {" "}
              {t("terms-and-conditions.content3.list7")}{" "}
            </li>
            <li className="ps-5">
              {" "}
              {t("terms-and-conditions.content3.list8")}{" "}
            </li>
            <li className="ps-5">
              {" "}
              {t("terms-and-conditions.content3.list9")}{" "}
            </li>
            <li className="ps-5">
              {" "}
              {t("terms-and-conditions.content3.list10")}{" "}
            </li>
            <li className="ps-5">
              {" "}
              {t("terms-and-conditions.content3.list11")}
            </li>
            <li className="ps-5">
              {" "}
              {t("terms-and-conditions.content3.list12")}
            </li>
            <li className="ps-5">
              {" "}
              {t("terms-and-conditions.content3.list13")}
            </li>
            <li className="ps-5">
              {" "}
              {t("terms-and-conditions.content3.list14")}
            </li>
            <li className="ps-5">
              {" "}
              {t("terms-and-conditions.content3.list15")}
            </li>
            <li className="ps-5">
              {" "}
              {t("terms-and-conditions.content3.list16")}
            </li>
            <li className="ps-5">
              {" "}
              {t("terms-and-conditions.content3.list17")}
            </li>
          </ol>
          <br />
          <p>
            {t("terms-and-conditions.content3.line2")}

          </p>
        </div>
      ),
    },
    {
      title: t("terms-and-conditions.title4"),
      content: (
        <p className="exado-subTitle-two">
          {t("terms-and-conditions.content4.line1")}
          <br />
          <br />
          {t("terms-and-conditions.content4.line2")}
          <br />
          <br />
          {t("terms-and-conditions.content4.line3")}
          <br />
          <br />
          {t("terms-and-conditions.content4.line4")}
          <br />
          <br />
          {t("terms-and-conditions.content4.line5")}
          <br />
          <br />
          {t("terms-and-conditions.content4.line6")}
        </p>
      ),
    },
    {
      title: t("terms-and-conditions.title5"),
      content: (
        <p className="exado-subTitle-two">
          {t("terms-and-conditions.content5.line1")}
          <br />
          <br />
          {t("terms-and-conditions.content5.line2")}
          <br />
          <br />
          {t("terms-and-conditions.content5.line3")}
        </p>
      ),
    },
    {
      title: t("terms-and-conditions.title6"),
      content: (
        <p className="exado-subTitle-two">
          {t("terms-and-conditions.content6.line1")}
          <br />
          <br />
          {t("terms-and-conditions.content6.line2")}
          <br />
          <br />
          {t("terms-and-conditions.content6.line3")}
          <br />
          <br />
          {t("terms-and-conditions.content6.line4")}
          <br />
          <br />
          {t("terms-and-conditions.content6.line5")}
          <br />
          <br />
          {t("terms-and-conditions.content6.line6")}
        </p>
      ),
    },
    {
      title: t("terms-and-conditions.title7"),
      content: (
        <p className="exado-subTitle-two">
          {t("terms-and-conditions.content7.line1")}
          <br />
          <br />
          {t("terms-and-conditions.content7.line2")}
          <br />
          <br />
          {t("terms-and-conditions.content7.line3")}
          <br />
          <br />

        </p>
      ),
    },
    {
      title: t("terms-and-conditions.title8"),
      content: (
        <p className="exado-subTitle-two">
          {t("terms-and-conditions.content8.line1")}
        </p>
      ),
    },
    {
      title: t("terms-and-conditions.title9"),
      content: (
        <p className="exado-subTitle-two">
          {t("terms-and-conditions.content9.line1")}
          <br />
          <br />
          {t("terms-and-conditions.content9.line2")}
        </p>
      ),
    },
    {
      title: t("terms-and-conditions.title10"),
      content: (
        <p className="exado-subTitle-two">
          {t("terms-and-conditions.content10.line1")}
          <br />
          <br />
          {t("terms-and-conditions.content10.line2")}
          <br />
          <br />
          {t("terms-and-conditions.content10.line3")}
          <br />
          <br />
          {t("terms-and-conditions.content10.line4")}
          <br />
          <br />
          {t("terms-and-conditions.content10.line5")}
          <br />
          <br />
          {t("terms-and-conditions.content10.line6")}
          <br />
          <br />
          {t("terms-and-conditions.content10.line7")}
        </p>
      ),
    },
    {
      title: t("terms-and-conditions.title11"),
      content: (
        <p className="exado-subTitle-two">
          {t("terms-and-conditions.content11.line1")}
          <br />
          <br />
          {t("terms-and-conditions.content11.line2")}
          <br />
          <span>{t("terms-and-conditions.content11.line3")}</span>
        </p>
      ),
    },
    {
      title: t("terms-and-conditions.title12"),
      content: (
        <p className="exado-subTitle-two">
          {t("terms-and-conditions.content12.line1")}
          <br />
          <br />
          {t("terms-and-conditions.content12.line2")}
          <br />
          {t("terms-and-conditions.content12.line3")}
        </p>
      ),
    },
    {
      title: t("terms-and-conditions.title13"),
      content: (
        <p className="exado-subTitle-two">
          {t("terms-and-conditions.content13.line1")}
        </p>
      ),
    },
    {
      title: t("terms-and-conditions.title14"),
      content: (
        <p className="exado-subTitle-two">
          {t("terms-and-conditions.content14.line1")}
        </p>
      ),
    },
    {
      title: t("terms-and-conditions.title15"),
      content: (
        <div>
          <div>
            <p className="exado-title-three my-5">
              {t("terms-and-conditions.title15.1")}
            </p>

            <p className="exado-subTitle-two">
              {t("terms-and-conditions.content15-1.line1")}
            </p>
          </div>
          <div>
            <p className="exado-title-three my-5">
              {t("terms-and-conditions.title15.2")}
            </p>
            <p className="exado-subTitle-two">
              {" "}
              {t("terms-and-conditions.content15-2.line1")}
            </p>
          </div>
          <div>
            <p className="exado-title-three my-5">
              {t("terms-and-conditions.title15.3")}
            </p>
            <p className="exado-subTitle-two">
              {" "}
              {t("terms-and-conditions.content15-3.line1")}
              <br />
              {t("terms-and-conditions.content15-3.line2")}
              <br />
              <br />
              {t("terms-and-conditions.content15-3.line3")}
              <br />
              {t("terms-and-conditions.content15-3.line4")}
            </p>
          </div>
          <div>
            <p className="exado-title-three my-5">
              {t("terms-and-conditions.title15.4")}
            </p>
            <div>
              <p className="exado-subTitle-two">
                {t("terms-and-conditions.content15-4.line1")}
              </p>
              <ul className="exado-subTitle-two">
                <li>{t("terms-and-conditions.content15-4.list1")}</li>
                <li>{t("terms-and-conditions.content15-4.list2")}</li>
                <li>{t("terms-and-conditions.content15-4.list3")}</li>
                <li>{t("terms-and-conditions.content15-4.list4")}</li>
                <li>{t("terms-and-conditions.content15-4.list5")}</li>
                <li>{t("terms-and-conditions.content15-4.list6")}</li>
                <li>{t("terms-and-conditions.content15-4.list7")}</li>
              </ul>
            </div>
          </div>
          <div>
            <p className="exado-title-three my-5">
              {t("terms-and-conditions.title15.5")}
            </p>
            <p className="exado-subTitle-two">
              {" "}
              {t("terms-and-conditions.content15-5.line1")}
              <br />
              <br />
              {t("terms-and-conditions.content15-5.line2")}
              <br />
              <br />
              {t("terms-and-conditions.content15-5.line3")}
              <br />
              <br />
              {t("terms-and-conditions.content15-5.line4")}
              <br />
              <br />
              {t("terms-and-conditions.content15-5.line5")}
              <br />
              <br />
              {t("terms-and-conditions.content15-5.line6")}
              <br />
              <br />
              {t("terms-and-conditions.content15-5.line7")}
              <br />
              <br />
              {t("terms-and-conditions.content15-5.line8")}
              <br />
              <br />
              {t("terms-and-conditions.content15-5.line9")}
            </p>
          </div>

          <div>
            <p className="exado-title-three my-5">
              {t("terms-and-conditions.title15.6")}
            </p>
            <p className="exado-subTitle-two">
              {" "}
              {t("terms-and-conditions.content15-6.line1")}
            </p>
          </div>
          <div>
            <p className="exado-title-three my-5">
              {t("terms-and-conditions.title15.7")}
            </p>
            <p className="exado-subTitle-two">
              {" "}
              {t("terms-and-conditions.content15-7.line1")}
            </p>
          </div>
          <div>
            <p className="exado-title-three my-5">
              {t("terms-and-conditions.title15.8")}
            </p>
            <p className="exado-subTitle-two">
              {" "}
              {t("terms-and-conditions.content15-8.line1")}
              <br />
              {t("terms-and-conditions.content15-8.line2")}
            </p>
          </div>
          <div>
            <p className="exado-title-three my-5">
              {t("terms-and-conditions.title15.9")}
            </p>
            <p className="exado-subTitle-two">
              {" "}
              {t("terms-and-conditions.content15-9.line1")}
            </p>
            <p className="exado-subTitle-two">
              {t("terms-and-conditions.content15-9.line2")}
              <br />
              {t("terms-and-conditions.content15-9.line3")}
              <br />
              {t("terms-and-conditions.content15-9.line4")}
              <br />
              {t("terms-and-conditions.content15-9.line5")}
              <br />
              {t("terms-and-conditions.content15-9.line6")}
            </p>
            <br />
            <p className="exado-subTitle-two">
              {t("terms-and-conditions.content15-9.line7")}
              <br />
              {t("terms-and-conditions.content15-9.line8")}
            </p>
            <br />
            <p className="exado-subTitle-two ">
              {t("terms-and-conditions.content15-9.line9")}
            </p>
          </div>
        </div>
      ),
    },
  ];
  return (
    <div className="terms-condition-page">
      <section className="terms-condition-section">
        <h2 className="exado-title-two ">
          {t("terms-and-conditions.page_heading")}
        </h2>

        {termsCondition.map((item, index) => (
          <article key={index} className="terms-condition-article">
            <div>
              <h1 className="exado-subTitle-one mb-4">
                {index + 1}. {item.title}
              </h1>
              {item.content}
            </div>
          </article>
        ))}
      </section>
    </div>
  );
};

export default TermsCondition;
